import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_EASY_CANCEL_LOWER_SUBS_AMOUNT = defineFcm('easy_cancel_lower_subs_amount')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experiment_name: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'One Click Subscription Cancel Page',
		description:
			'This FCM config controls whether or not to show the lower subscription amount on the one click subscription cancel page.',
		template: {
			enabled: false,
			experiment_name: 'easy_cancel_lower_subs_amount',
		},
	});
